import React from 'react'
import ErrorDialog from 'src/components/common/ErrorDialog'
import { ERROR_MESSAGES } from 'src/utils/constants/common'

const GraphQlErrors = ({ error, routeValue }) => {
  return (
    <div data-test='graphqlErrorComponent'>
      {error?.graphQLErrors?.map((err2, index) => {
        const errorCode = err2?.extensions?.errorCode
        const errorMessage = ERROR_MESSAGES[errorCode?.replace('-', '_')]

        if (errorMessage) {
          return (
            <ErrorDialog
              key={errorCode}
              message={errorMessage}
              routeValue={routeValue}
            />
          )
        }

        return <p key={index}>error</p>
      })}
    </div>
  )
}

export default GraphQlErrors
